module.exports = __webpack_public_path__ + "img/logo_x2.f1794264.png";